export enum MoovStepInstanceState {
    Pending = 0,
    InProgress = 1,
    Done = 100
}

export enum MoovEventTypeEnum {
    LifetimeStart = 1,
    LifetimeEnd = 2,
    Feedback = 3,
    LifetimeExtention = 4,
    UserComment = 5,
    StepDone = 6
}

export enum MoovTypeEnum {
    Standard = 1,
    Short = 2
}